import React from "react";
import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import arrow from "../../../assets/svgs/Vector.svg";
import { media } from "utils/style";

const Tile = ({ children, onClick, tileType, href, linkText, to, ...props }) => {
  if (tileType === "button") {
    return (
      <TileButton className="flex_item" onClick={onClick} {...props}>
        <span className="tile_text">{children}</span>
        {linkText && <span className="tile_desc">{linkText}</span>}
        <span aria-hidden="true" className="tile_arrow" />
      </TileButton>
    );
  } else if (tileType === "reactLink") {
    return (
      <TileReactLink className="flex_item" to={to} {...props}>
        <span className="tile_text">{children}</span>
        {linkText && <span className="tile_desc">{linkText}</span>}
        <span aria-hidden="true" className="tile_arrow" />
      </TileReactLink>
    );
  }
  return (
    <TileAnchor className="flex_item" href={href} {...props}>
      <span className="tile_text">{children}</span>
      {linkText && <span className="tile_desc">{linkText}</span>}
      {/* <span aria-hidden="true" className="tile_arrow" />     */}
      <img src={arrow} aria-hidden="true" alt="" />




    </TileAnchor>
  );
};

export default Tile;

const style = css`
  ${props => props.style && { ...props.style }}

  position: relative;
  text-align: left;
  background: 0;
  box-shadow: 1px 0 0 0 #d8dada, 0 1px 0 0 #d8dada, 1px 1px 0 0 #d8dada, 1px 0 0 0 #d8dada inset,
    0 1px 0 0 #d8dada inset;
  padding: 0;
  width: 100%;
  min-height: 174px;
  cursor: pointer;
  text-decoration: none;
  display: flex;
  flex-direction: column;
  flex-basis: 33.33%;

  img {
    position: absolute;
    height: 18px;
    width: 18px;
    bottom: 20px;
    right: 20px;
  }

  ${media.tablet`
    flex-basis: 50%;    
  `}

  ${media.mobile`
    flex-basis: 100%;
  `}

  :focus {
    z-index: 9;
  }

  .tile_desc {
    /* position: absolute;
    bottom: 20px;
    left: 20px;
    max-width: 80%; */
    font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-size: 12px;
    line-height: 14px;
    margin: 0 20px 20px 20px;
    max-width: 297px;
  }

  .tile_arrow {
    position: absolute;
    height: 18px;
    width: 18px;
    transform: rotate(-45deg);
    bottom: 20px;
    right: 20px;
    top: unset;
    left: unset;
    border-right: 3px solid;
    border-bottom: 3px solid;
  }

  .tile_text {
    font-size: 32px;
    line-height: 30px;
    /* position: absolute;
    top: 20px;
    left: 20px; */
    font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-weight: 700;
    /* max-width: 75%; */
    margin: 20px;
  }

  ${media.mobile`
    .tile_text {
      /* max-width: 80%; */
      font-size: 26px;
      line-height: 24px;
    }
  `}
`;

const TileButton = styled.button`
  ${style}
`;

const TileAnchor = styled.a`
  ${style}
`;

const TileReactLink = styled(Link)`
  ${style}
`;
